// extracted by mini-css-extract-plugin
export default {"loaderContainer":"Loader_loaderContainer__J38Mu","spinner":"Loader_spinner__ipJnA","spin":"Loader_spin__FVEr9"};